import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModelOnboardingHomeComponent } from '@angular-workspace/feature';
import { OrgAdminSidebarComponent } from '../sidebar/org-admin-sidebar.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { ToasterService } from '../../services/toaster.service';

@Component({
  selector: 'app-org-admin-add-model',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    OrgAdminSidebarComponent,
    PageHeaderComponent,
    ModelOnboardingHomeComponent,
  ],
  templateUrl: './add-model.component.html',
  styleUrl: './add-model.component.scss',
})
export class OrgAdminAddModelComponent {
  private readonly toasterService = inject(ToasterService);

  onSubmitError(message: string): void {
    this.toasterService.error(message);
  }

  onSubmitSuccess(message: string): void {
    this.toasterService.success(message);
  }
}
